module.exports = __webpack_public_path__ + "img/no-button_hover.9c440691.png";